import axios from 'axios'
import context from '../main.js'
import { getUserToken } from '../../static/js/userToken'
class HttpRequest {
    constructor(baseUrl = baseURL) {
        this.baseUrl = baseUrl
        this.queue = {}
    }
    getInsideConfig() {
        const config = {
            baseURL: this.baseUrl,
            headers: {

            }
        }
        return config
    }
    destroy(url) {
        delete this.queue[url]
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }
    interceptors(instance, url) {
        getUserToken();
        let userToken = sessionStorage.getItem("ltmUserToken");
        // 请求拦截
        instance.interceptors.request.use(config => {
                if (userToken) {
                    config.headers['Authorization'] = userToken;
                }
                // config.headers['Authorization'] = "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIiLCJob3NwaXRhbElkIjoiV2VpRHVvTGlZYSIsImN1c3RvbWVySWQiOiJlYzczODk4MGU4ODU0YzBmOTliMWM1MmE3YTgzYTcxZiIsInR5cGUiOiJjdXN0b21lciIsImV4cCI6MTU2NTU5NDAwNSwidXNlcklkIjoib3o4VDMxVlEwUVVyNFdNU0kxeDdlMEc5YlBDUSIsImlhdCI6MTU2NTU4NjgwNSwianRpIjoiMjRiMjYzOTQtZTZhYy00MTYyLThmNTUtZDUzNmRlOTk3MjIwIn0.ugdTU1q4210fj83dMI5ZXIG4Hwu0DoVB5bXiOZoP8g0"; //添加token
                // 添加全局的loading...
                if (!Object.keys(this.queue).length) {
                    // Spin.show() // 不建议开启，因为界面不友好  
                }
                this.queue[url] = true
                return config
            }, error => {
                return Promise.reject(error)
            })
            // 响应拦截
        instance.interceptors.response.use(res => {
            //拦截消息
            if (res.data.code == -1) {
                context.errorMessage(res.data.msg)
            }
            this.destroy(url)
            const { data, status } = res
            return { data, status }
        }, error => {
            this.destroy(url)
            return Promise.reject(error)
        })
    }
    request(options) {
        const instance = axios.create()
        options = Object.assign(this.getInsideConfig(), options)
        this.interceptors(instance, options.url)
        return instance(options)
    }
}
export default HttpRequest


// WEBPACK FOOTER //
// ./src/libs/axios.js